import FormatCurrency from 'components/Common/FormatCurrency'
import BodyText from '../Typography/BodyText'
import Caption from '../Typography/Caption'

interface Props {
  size?: 'small' | 'medium' | 'large'
  price?: number
  label?: string
  priceColour?: Extract<App.Design.ContentColour, 'lux-plus'>
}

/**
 * This is a common list item "slot" component.
 * It should be used and composed as a ListItem children
 * It is used to show price information about the list item.
 */
function ListItemPrice(props: Props) {
  const { price, label, size = 'large', priceColour } = props
  const captionSize = size === 'large' ? 'large' : 'medium'

  return <div>
    {label && <Caption wrap="no-wrap" variant={captionSize} align="end" colour="light-foreground-alt">
      {label}
    </Caption>}
    {price !== undefined && <BodyText align="end" variant={size} colour={priceColour}>
      <FormatCurrency value={price} />
    </BodyText>}
  </div>
}

export default ListItemPrice
